<!--<template>-->
<!--    <div class="def-darken-background">-->
<!--        DefDarkenBackground-->
<!--    </div>-->
<!--</template>-->

<script>
export default {
  name: 'DefDarkenBackground',
  props: ['result'],
  data() {
    return {
      background: null,
    };
  },
  mounted() {
    this.createBackground();
  },
  beforeUnmount() {
    this.removeBackground();
  },
  methods: {
    createBackground() {
      const div = document.createElement('div');
      div.classList.add('filter-background');
      div.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 1000;
                opacity: 0;
                transition: .2s linear opacity;
                background-color: rgba(0, 0, 0, .2);
            `;

      div.addEventListener('click', () => this.$emit('close'));

      document.body.append(div);

      setTimeout(() => (div.style.opacity = 1), 4);

      this.background = div;
    },
    removeBackground() {
      this.background.style.opacity = 0;
      setTimeout(() => this.background.remove(), 200);
    },
  },
  render() {
    return null;
  },
};
</script>

<style lang="scss" scoped>
.def-darken-background {
}
</style>
